/* MG Back-in-Stock (Klaviyo) — additive, MG-custom.
   Shows the "notify me" form when the selected variant is unavailable, tracks
   variant changes (FoxTheme pubsub) so it follows size switches, and subscribes
   via the PUBLIC Klaviyo Back-in-Stock Client API (no private key). Requires the
   Klaviyo app's product catalog — until that syncs the API returns 404
   variant_not_found and the form shows the error state (never a false success).
   Config + texts come from snippets/mg-back-in-stock.liquid (window.mgBis).
   All DOM built with createElement/textContent (no innerHTML). */
(function () {
  'use strict';
  var cfg = window.mgBis || {};
  if (!cfg.publicKey) return;
  var root = document.querySelector('[data-mg-bis]');
  if (!root) return;

  var form = root.closest('.product-form') || document;
  var submitBtn = form.querySelector('.product-form__submit');
  var buttonsWrap = form.querySelector('.product-form__buttons'); // quantity + add-to-cart
  var currentVariantId = cfg.variantId ? String(cfg.variantId) : '';

  function isSoldOut() { return !!(submitBtn && submitBtn.hasAttribute('disabled')); }
  function toggle() {
    var sold = isSoldOut();
    if (sold) root.removeAttribute('hidden');
    else root.setAttribute('hidden', '');
    // When the notify form is shown, hide the redundant quantity + disabled "Sold out" button.
    if (buttonsWrap) buttonsWrap.style.display = sold ? 'none' : '';
  }
  toggle();

  function onVariant(variant) {
    if (variant && variant.id) currentVariantId = String(variant.id);
    setTimeout(toggle, 0); // let the theme update the button's disabled state first
  }
  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS && FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (d) {
      var v = (d && d.data && d.data.variant) || (d && d.variant) || null;
      onVariant(v);
    });
  }
  if (submitBtn && window.MutationObserver) {
    new MutationObserver(toggle).observe(submitBtn, { attributes: true, attributeFilter: ['disabled'] });
  }

  var bisForm = root.querySelector('form');
  var zone = root.querySelector('[data-mg-bis-zone]');
  if (bisForm && zone) {
    bisForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = bisForm.querySelector('input[type="email"]');
      if (!input || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(input.value || '')) {
        if (input) { input.classList.add('mg-bis__input--invalid'); input.focus(); }
        return;
      }
      clearError();
      var email = input.value.trim();
      var btnEl = bisForm.querySelector('button[type="submit"]');
      if (btnEl) { btnEl.disabled = true; btnEl.classList.add('mg-bis__btn--loading'); }
      subscribe(email).then(function (ok) {
        if (ok) { showSuccess(); }
        else { if (btnEl) { btnEl.disabled = false; btnEl.classList.remove('mg-bis__btn--loading'); } showError(); }
      });
    });
  }

  function subscribe(email) {
    if (!currentVariantId) return Promise.resolve(false);
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email,
          properties: { language: cfg.lang, market: cfg.market, source: 'Back in Stock' } } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + currentVariantId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(cfg.publicKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.status >= 200 && r.status < 300; }).catch(function () { return false; });
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function showSuccess() {
    var t = cfg.texts || {};
    while (zone.firstChild) zone.removeChild(zone.firstChild);
    var wrap = el('div', 'mg-bis__success');
    var check = el('span', 'mg-bis__check'); check.setAttribute('aria-hidden', 'true');
    wrap.appendChild(check);
    wrap.appendChild(el('div', 'mg-bis__success-heading', t.success_heading || ''));
    wrap.appendChild(el('div', 'mg-bis__success-body', t.success_body || ''));
    zone.appendChild(wrap);
  }
  function showError() {
    if (zone.querySelector('.mg-bis__error')) return;
    var t = cfg.texts || {};
    var p = el('div', 'mg-bis__error', t.error || 'Please try again.');
    p.setAttribute('role', 'alert');
    zone.appendChild(p);
  }
  function clearError() { var e = zone.querySelector('.mg-bis__error'); if (e) e.remove(); }
})();
